<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Empty layout -->
<!-- ----------------------------------------------------------------------------------------------------- -->
<empty-layout *ngIf="layout === 'empty'"></empty-layout>



<!-- Compact -->
<compact-layout *ngIf="layout === 'compact'"></compact-layout>

